import { Dispatch, bindActionCreators } from 'redux';
import { Patient, PatientStateProps, PatientDispatchProps, PatientOwnProps } from '../components/patient/Patient';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { setVisitCode } from '../redux/ui/actions';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';
import { toast } from '../redux/message/actions';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState, ownProps: PatientOwnProps): PatientStateProps {
  return {
    visitCode: state.ui.visitCode,
    visitConfig: state.visits.visitConfig,
    markets: state.markets.markets,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): PatientDispatchProps {
  return {
    actions: bindActionCreators(
      {
        setVisitCode,
        onPageDidMount,
        onPageWillUnmount,
        toast,
      },
      dispatch
    ),
  };
}

export const PatientContainer = withRouter(connect<PatientStateProps, PatientDispatchProps, PatientOwnProps, RootState>(mapStateToProps, mapDispatchToProps)(Patient));
